import { format as formatWithoutTimezone } from 'date-fns';
import { formatToTimeZone } from 'date-fns-timezone';
import { useMemo } from 'react';

type Props = {
  date: Date;
  timezone?: string;
  format: keyof typeof DateFormat;
};

const DateFormat = {
  long: {
    base: 'd MMM, yyy-HH:mm',
    timezone: 'D MMM, YYYY-HH:mm',
  },
  medium: {
    base: 'd MMM, yyy',
    timezone: 'D MMM, YYYY',
  },
  longWithSeconds: {
    base: 'd MMM, yyy-HH:mm:ss',
    timezone: 'D MMM, YYYY-HH:mm:ss',
  },
};

export const DateLabel: React.FC<Props> = ({ date, timezone, format }) => {
  const timezones = useMemo(() => Intl.supportedValuesOf?.('timeZone') ?? [], []);

  return timezone !== undefined && timezones.find((tz) => tz === timezone) !== undefined ? (
    <>{formatToTimeZone(date, DateFormat[format].timezone, { timeZone: timezone })}</>
  ) : (
    <>{formatWithoutTimezone(date, DateFormat[format].base)}</>
  );
};

export const convertTimestampToISOString = (timestamp: number): string => {
  if (timestamp.toString().length === 10) {
    timestamp *= 1000;
  }
  return new Date(timestamp).toISOString();
};

export const convertMillisecondsToTimeParts = (ms: number) => {
  const totalMinutes = Math.floor(ms / (1000 * 60));
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;
  return `${days}d ${hours}h ${minutes}m`;
};
